<template>
  <div class="full-width p-x-15 font-14">
    <tk-flex class="p-y-20">
      <div style="width:70px;flex-shrink:0;color: #666666">项目名称:</div>
      <div style="flex-grow:1;color: #222222" class="p-l-5">{{announcement.headline}}</div>
    </tk-flex>
    <tk-flex class="p-b-20">
      <div style="width:70px;flex-shrink:0;color: #666666">保证金:</div>
      <div v-if="announcement.tenderMethod !== 'percentLowerBid'" style="flex-grow:1;color: #222222" class="p-l-5">￥{{ Number(Number(announcement.upper) * (bondBase / 100)).toFixed(2) || "" }}</div>
      <div v-else style="flex-grow:1;color: #222222" class="p-l-5">￥{{ Number(announcement.bond.amount) }}</div>
    </tk-flex>
    <tk-flex class="p-b-20">
      <div style="width:70px;flex-shrink:0;color: #666666">成交方式:</div>
      <div style="flex-grow:1;color: #222222" class="p-l-5">{{ tenderMethod }}</div>
    </tk-flex>
    <tk-flex class="p-b-20">
      <div style="width:70px;flex-shrink:0;color: #666666">项目编号:</div>
      <div style="flex-grow:1;color: #222222" class="p-l-5">{{ announcement.announcementId || '-' }}</div>
    </tk-flex>
    <tk-flex class="p-b-20">
      <div style="width:70px;flex-shrink:0;color: #666666">支付时间:</div>
      <div style="flex-grow:1;color: #222222" class="p-l-5">{{ datetime(bidRecord.payRecord.payTime) }}</div>
    </tk-flex>
    <tk-flex class="p-x-15 p-b-50">
      <div class="full-width ant-btn" @click="uploadFile">
        上传响应资料
      </div>
    </tk-flex>
  </div>
</template>
<script>
import './jgoldplan-1.0.0'
export default {
  data () {
    return {
      cloudUrl: '', // 云代码地址
      baseUrl: '', // 网页地址
      mchID: '',
      orderId: '',
      bidRecord: {
        payRecord: {}
      },
      announcement: {},
      bondBase: 5,
      tenderMethodArr: [
        {
          type: 'onlineBidding',
          name: '网上竞价'
        },
        {
          type: 'randomDrawing',
          name: '随机抽取'
        },
        {
          type: 'directSelection',
          name: '直接选取'
        },
        {
          type: 'percentLowerBid',
          name: '千分比选取'
        }
      ]
    }
  },
  mounted () {
    try {
      const mchData = { action: 'onIframeReady', displayStyle: 'SHOW_CUSTOM_PAGE' }
      const postData = JSON.stringify(mchData)
      parent.postMessage(postData, 'https://payapp.weixin.qq.com')
      this.getInit()
    } catch (e) {
      console.log(e)
    }
  },
  computed: {
    tenderMethod () {
      let index = this.tenderMethodArr.findIndex(
        e => e.type === this.announcement.tenderMethod
      )
      if (index === -1) return ''
      return this.tenderMethodArr[index].name
    }
  },
  methods: {
    async getInit () {
      try {
        // 获取商户订单号
        this.orderId = this.getUrlKey(`out_trade_no`)
        // 获取商户号
        this.mchID = this.getUrlKey('sub_mch_id')
        // 是隆尧
        if (this.mchID === '1618358274') {
          this.cloudUrl = 'https://cloud.lyxejy.mokekeji.com'
          this.baseUrl = 'https://lyxejy.xtly0319.com'
        }
        // 是巨鹿
        if (this.mchID === '1628195934') {
          this.cloudUrl = 'https://cloud.jlxejy.mokekeji.com'
          this.baseUrl = 'https://xtjlxejy.com'
        }
        let { data: res } = await this.$tkParse.get(`${this.cloudUrl}/classes/payRecord/${this.orderId}`, {
          params: {
            include: 'announcement,announcement.user,user,user.company,bidRecord,bidRecord.payRecord'
          }
        })
        this.bidRecord = res.bidRecord
        this.announcement = res.announcement
        await this.getBondBase()
      } catch (e) {
        console.log(e)
      }
    },
    // 获取保证金基数
    async getBondBase () {
      let { data: res } = await this.$tkParse.get(`${this.cloudUrl}/settings/bondBase`)
      this.bondBase = res
    },
    uploadFile () {
      let mchData = {
        action: 'jumpOut',
        jumpOutUrl: `${this.baseUrl}/wxuploadBidFile?recordId=${this.bidRecord.objectId}`
        // jumpOutUrl: `http://bhjx.test.mokekeji.com/wxuploadBidFile?recordId=${this.bidRecord.objectId}`
      }
      let postData = JSON.stringify(mchData)
      parent.postMessage(postData, 'https://payapp.weixin.qq.com')
    },
    datetime (isoString) {
      let date = new Date(isoString)
      return [[date.getFullYear(), date.getMonth() + 1, date.getDate()].join('-'),
        [date.getHours(), date.getMinutes()].join(':')
      ].join(`     `).replace(/(?=\b\d\b)/g, '0')
    },
    // 获取参数
    getUrlKey (name) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || ['', ''])[1].replace(/\+/g, '%20')) || null
    }
  }
}
</script>
<style lang="scss" scoped>
.ant-btn{
  width: 100%;
  height: 44px;
  color: #fff;
  background-color: #1890ff;
  border-color: #1890ff;
  text-shadow: 0 -1px 0 rgb(0 0 0 / 12%);
  box-shadow: 0 2px 0 rgb(0 0 0 / 5%);
  line-height: 44px;
  text-align: center;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
</style>
